import { forwardRef, Ref } from 'react';

import clsx from 'clsx';

import RadioCheckedIcon from '../../../../icons.deprecated/RadioCheckedIcon';
import RadioUncheckedIcon from '../../../../icons.deprecated/RadioUncheckedIcon';
import { omit } from '../../../../utils/helpers';
import { FormControlLabel, Props, Radio, radioOptionClasses } from './styles';
import useRadioOption from './vm';

export type { Props };
export { radioOptionClasses };

const RadioOption = (
  { labelPlacement, value, children, disabled, className, classes, ...props }: Props,
  ref: Ref<HTMLInputElement>
) => {
  const { contextValue, handleChange, handleInputClick } = useRadioOption({ disabled });

  const ariaHidden = props['aria-hidden'];
  const ariaLabel = props['aria-label'];
  const ariaLabelledby = props['aria-labelledby'];
  const role = props.role;

  return (
    <FormControlLabel
      ref={ref}
      label={children}
      labelPlacement={labelPlacement}
      value={value}
      disabled={disabled}
      disableTypography={typeof children !== 'string'}
      color={props.color}
      className={clsx(radioOptionClasses.root, className, classes?.root)}
      classes={{
        root: clsx(radioOptionClasses.root, classes?.root),
        label: clsx(radioOptionClasses.label, classes?.label),
        disabled: clsx(radioOptionClasses.labelDisabled, classes?.labelDisabled),
      }}
      role={role}
      {...(ariaHidden
        ? { 'aria-hidden': true }
        : ariaLabel
        ? { 'aria-label': ariaLabel }
        : ariaLabelledby
        ? { 'aria-labelledby': ariaLabelledby }
        : {})}
      control={
        <Radio
          {...omit(props, 'aria-hidden', 'aria-label', 'aria-labelledby', 'role')}
          inputProps={{
            ...props.inputProps,
            value,
            onChange: handleChange,
            // MUI does not trigger onChange when a checked radio button is clicked again, even when it is uncheckable
            // But MUI triggers onClick always
            onClick: (e) => {
              props.inputProps?.onClick?.(e);
              handleInputClick(e as any);
            },
          }}
          className={clsx(radioOptionClasses.radioRoot, classes?.radioRoot, {
            [radioOptionClasses.disabled]: disabled,
            [radioOptionClasses.checked]: contextValue === value,
          })}
          classes={{
            root: clsx(radioOptionClasses.radioRoot, classes?.radioRoot),
            radio: clsx(radioOptionClasses.radio, classes?.radio),
          }}
          icon={
            <RadioUncheckedIcon
              sx={{ fontSize: 'inherit' }}
              className={clsx(radioOptionClasses.icon, classes?.icon)}
            />
          }
          checkedIcon={
            <RadioCheckedIcon
              sx={{ fontSize: 'inherit' }}
              className={clsx(radioOptionClasses.checkedIcon, classes?.checkedIcon)}
            />
          }
        />
      }
    />
  );
};

export default forwardRef(RadioOption);
